<template>
  <div>
    <el-dialog
      title=""
      :visible.sync="isOpen"
      width="1000px"
      top="10vh"
      :close-on-click-modal="false"
      :append-to-body="isAppend"
      custom-class="word-info"
      :before-close="handleCloseBefore">
      <div class="title">中国足球协会关于举办2024年亚足联/中国足协精英青训B级、A级教练员证书培训班和中国足协青训总监培训班的通知</div>
      <div class="content-info">
        <vue-scroll :ops="vuescrollOpt">
          <div class="wrapper">
            <p class="first_line">各会员协会、俱乐部、相关教练员：</p>
            <p class="first_line"></p>
            <p class="info">为落实《中国足球改革发展总体方案》，改进足球专业人才培养方式，加快提升青训教练整体水平，根据工作计划，将于2024年10月至2025年1月期间举办第一期亚足联/中国足协精英青训B级、精英青训A级教练员证书培训班和青训总监培训班，详见中国足协官网相关通知。现将培训报名事宜通知如下：</p>
            <p class="info">一、报名方式</p>
            <p class="info">请报名人员在本页面附件下载报名表。填写报名表，经本人签字和会员协会盖章后，将报名表、身份证、体检报告（6个月内，二级甲等及以上医院或正规体检机构出具）扫描件发联系人电子邮箱。</p>
            <p class="info">二、联系人及联系方式</p>
            <p class="info">中国足协技术部：顾林</p>
            <p class="info">固定电话：010-59291021</p>
            <p class="info">手机：13901020280（微信同号）</p>
            <p class="info">邮箱：gu.lin@thecfa.cn</p>
            <p class="info">附件：<a :href="loadExcelUrlB" class="document">精英青训B级报名表</a></p>
            <p class="info" style="text-indent: 5em"><a :href="loadExcelUrlA" class="document">精英青训A级报名表</a></p>
            <p class="info" style="text-indent: 5em"><a :href="loadExcelUrlZ" class="document">青训总监报名表</a></p>
          </div>
        </vue-scroll>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { signLevelFilters } from "@/assets/js/yioksFilters";
  import createScrollOpt from "@/assets/js/vuescrollOption";
  export default {
    props: {
      isOpen: {
        type: Boolean,
        default: false
      },
      isAppend: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        vuescrollOpt: createScrollOpt(true),
        loadExcelUrlB: "/uploads/import_tpl/精英青训B级报名表.xlsx",
        loadExcelUrlA: "/uploads/import_tpl/精英青训A级报名表.xlsx",
        loadExcelUrlZ: "/uploads/import_tpl/青训总监报名表.xlsx",
      }
    },

    filters: {
      signLevelFilters,
    },

    computed: {
    
    },

    methods: {
      handleCloseBefore() {
        this.$emit('update:isOpen', false);
      }
    }
  }
</script>

<style lang="stylus" scoped>
.content-info
  height: 600px
  .first_line
    text-align: justify
    line-height: 2em
    font-size: 16px
    &:not(:last-child)
      margin-bottom: 10px
  .info
    text-indent: 2em
    text-align: justify
    line-height: 2em
    font-size: 16px
    &:not(:last-child)
      margin-bottom: 10px
  // .list-content
  //   padding 0 1em
  .document{
    cursor:pointer
    color:#4cd964
  }
  
.err
  color: #f88594
.wrapper
  margin 0 25px 0
.title
  width:  95%
  font-size: 20px
  display: flex
  align-items: center
  justify-content: center
  font-weight: 600
  margin: 0 20px 20px 20px
</style>

<style lang="stylus">

.word-info
  .el-dialog__body
    padding 30px 5px 30px 0px
</style>
